var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStackOverflowLogo = function SvgIconStackOverflowLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.364 3.068a1 1 0 1 0-1.285 1.533l5.747 4.819a1 1 0 0 0 1.285-1.533zm-4.9 6.171a1 1 0 0 1 1.282-.597l7.05 2.569a1 1 0 1 1-.685 1.879l-7.05-2.569a1 1 0 0 1-.597-1.282M5.5 14.25a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v5h-13zm2.75.875a1 1 0 0 0 0 2h7.5a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgIconStackOverflowLogo;